module.exports = __webpack_public_path__ + "img/intro-03.27089dbd.png";